var Marionette = require('marionette'),
    SubApp = require('../common/SubApp'),
    FindAndRedactState = require('./state'),
    Layout = require('./layout/layout'), // Maybe want a region to put inside depending on how render ...
    FindAndRedactNoteModelConverter = require('./models/noteModelConverter'),
    SearchModelsCollection = require('./models/SearchModelsCollection'),
    SearchModel = require('./models/SearchModel'),
    HiddenCanvasView = require('../canvas/hiddenCanvas/view'),
    SearchResults = require('./models/searchResults/SearchResults'),
    fvChannel = require('glRadio').channel('FV'),
    SearchView = require('./layout/searchView/view'),
    PredefinedSearchesWrapper = require('./models/api/PredefinedSearchesWrapper');


module.exports = SubApp.extend({

    channelName: 'findAndRedact',

    constructor: function( options, id ) {

        SubApp.prototype.constructor.apply( this, arguments );

        this.vChannel = options.vChannel;

        // Store a reference here instead of retrieving from vChannel -- it's used in multiple places in the module
        this.creatableNoteTypesHelper = options.creatableNoteTypesHelper;

        var predefinedSearchesWrapper = new PredefinedSearchesWrapper();

        if ( options.userProvidedSearches ) {

            predefinedSearchesWrapper.initialize(
                options.userProvidedSearches,
                this.creatableNoteTypesHelper.getDisallowedFindAndRedactNoteTypes(),
                this.channel._requests.getNewNoteModel.callback.bind( this )
            );

            this.showUserProvidedSearchWarnings( predefinedSearchesWrapper );


        }

        this.state = new FindAndRedactState({
            searches: predefinedSearchesWrapper.getValidSearchesWithPermission().length > 0
                ? new SearchModelsCollection( predefinedSearchesWrapper.getValidSearchesWithPermission() )
                : null
        });


        this.region = new Marionette.Region({ el: this.options.el });

        this.layout = null; // created on render -- which is like start

    },

    /* note -- all local */
    subscriptions: {

        'findAndRedact:search':                 'doSearch',
        'findAndRedact:showAddSearchModal':     'showAddSearchModal',
        'findAndRedact:showEditSearchModal':    'showEditSearchModal',
        'findAndRedact:removeSearch':           'removeSearch',
        'findAndRedact:toggleCollapseSearch':   'toggleCollapseSearch',

        'findAndRedact:clearSearch':                'clearSearch',
        'findAndRedact:apply':                      'apply',
        'findAndRedact:updateShowResultsByTable':   'updateShowResultsByTable',

        'findAndRedact:updatePostCollapseRowClick':         'updatePostCollapseRowClick',
        'findAndRedact:updatePostResultRowIncludeClick':    'updatePostResultRowIncludeClick',

        // These are forwards:
        'findAndRedact:userClickedHit':                 'userClickedHit',
        'findAndRedact:revertShapePosition':            'revertShapePosition',
        'findAndRedact:hitShapeReasonCodesChange':      'hitShapeReasonCodesChange'

    },

    /* -- note: these are local -- */
    requests: {

        vChannel: function() {
            return this.vChannel;
        },
        state: function() {
            return this.state;
        },
        creatableNoteTypesHelper: function() {
            return this.creatableNoteTypesHelper;
        },
        getNewSearchModel: function() {

            return new SearchModel({
                noteModel: this.request( 'getNewNoteModel' )
            });

        },

        /**
         *
         * 'Wrap' the new note model from the notes module
         * Optional: shapeAttrs -- note attrs may follow when set from API
         * ( for redactions, calls setSelectedCodeAndFillOnDialogOpen on the shape )
         */
        getNewNoteModel: function( noteType, shapeAttrs ) {
            noteType = noteType || this.defaultNoteType();
            var note = this.vChannel.request( 'getNewNoteModel', 0, noteType );
            FindAndRedactNoteModelConverter.convertNewNote( note, shapeAttrs );
            return note;

        }

    },

    /**
     * Perhaps this is configurable or remember across searches.
     * If don't have create_page-note, but can highlight, it has to be highlights ....
     */
    defaultNoteType: function() {

        if ( this.request('creatableNoteTypesHelper').getDisallowedFindAndRedactNoteTypes().indexOf( 'REDACTION_NOTE' ) > -1 ) {
            return 'HIGHLIGHT_NOTE';
        }

        return 'REDACTION_NOTE';

    },


    /* -- 'outer': s/b events but following old commands structure w/BB Radio like the other modules --
    * don't envision having inner commands here
    * hooks into existing sub app arch so no need to wire, unwire
    * */
    commands: {

        changePage: function (options) {

            if ( !this.state.searchHasResults() )
                return;

            /* We don't need an expense re-render here */
            this.state.getSearchResultsTree().updateCurrentPageNumber( options.pageNum );

        }

    },

    /* Initial and re-renders; also like a 'start' */
    render: function() {

        this.layout = new Layout({ channel: this.channel });

        /**
         * Perform a search on entry: used if searches are passed in --
         * kind of a hack: the predefined searches on the state are not yet 'searched'
         */
        this.region.once('show', function() {

            if ( !this.state.get('searchPerformed') && this.state.getNumberOfSearches() > 0 && this.state.allSearchesAreValid() ) {
                this.channel.trigger( 'findAndRedact:search' );
            }

        }.bind(this) ) ;

        this.region.show( this.layout );

    },

    /* -- Subscriptions -- */

    /**
     * Sources: 1) search form submit, 2) findAndRedactOnEntry -- either way searches will be set in state
     * Ultimately puts state into search performed -- we want to lock when user has results.
     */
    doSearch: function( search ) {

        if ( search ) {  // ( this would be for regular user search ) -- could do prior; on entry search are already set
            this.state.addSearch( search );
        }

        /* extra check -- maybe now we show an error */
        if ( !this.state.allSearchesAreValid() ) {
            return;
        }

        // If from form submit, obtain lock, and only allow if successful.
        // Lock will be cleared after search is cleared, or immediately search yields no results,
        // in which case the 'clear' button is not presented.
        this.request('vChannel').command(
            'lockActiveDocument', 'FIND_AND_REDACT', 'Find And Redact', this._performSearch.bind(this)
        );

    },

    // requestAnimationFrame necessary for spinner not to get skipped; cleaner than old timeouts; IE10+=
    // Note: spinner will be removed when the resultsRegion is shown
    _performSearch: function() {

        requestAnimationFrame( function() {

            this.channel.trigger('findAndRedact:showSpinner');

            requestAnimationFrame( function() {

                var searches = this.state.get('searches');

                var results = new SearchResults();  // need to clear first?
                searches.setNoteSubjectsOnSearch();
                results.buildResultsFromSearches( searches.models, this.channel );
                this.state.doSearch( results );

                this.channel.trigger('findAndRedact:hideSpinner'); // ( now called again in the layout )

                // No need to re-render the header ( it holds the spinner )
                this.layout.showBodyRegions();

                this.vChannel.command( 'setFindAndRedactSearchModel', this.state ); // ( the export portion )

                /**
                 * Persist search attributes only for those manually entered ( vs from the API ).
                 * ( There can only be one searched at a time manually now  ).
                 * Leave isAPI logic out of updateLocalStorageForRedactionNotes because searches from the API can be edited.
                 */

                var firstSearch = searches.at(0);
                if ( !firstSearch.get('fromAPI') && firstSearch.getNoteModel().isRedactionNote() ) {
                    searches.at(0).updateLocalStorageForRedactionNotes();
                }


            }.bind(this) );

        }.bind(this) );


    },

    /**
     * For now permissions are done separate from validation issues from frApiModel.
     * If there are no searches with approp. perms, a view is placed of the model stating 'User lacks permission to create any notes',
     * and blocking any action.
     * Alerts here will be displayed and printed in the console as warning regardless.
     * Those could be made more descriptive.
     * For now left on model, not the model, for display purposes with DV's alert -- later may want to re-org.
     * The error reporting can be made better if/when desired.
     */
    showUserProvidedSearchWarnings: function( predefinedSearchesWrapper ) {

        var frApiModel = predefinedSearchesWrapper.getApiModel();

        /* None Valid -- not alerting about permissions */
        if ( !frApiModel.hasValidSearches() ) {

            showWarnings.call( this, {
                shortMessage: 'Find And Redact API Invalid Input',
                detailedMsg: 'No valid searches provided.\n' + frApiModel.getValidationErrors().join('\n')
            });
            return;

        }


        var validSearchesWithoutPermission = predefinedSearchesWrapper.getValidSearchesWithoutPermission();
        var permissionWarningMessage;

        if ( validSearchesWithoutPermission.length > 0 ) {

            var oValidSearchesWithoutPermCountsPerNoteType = _.countBy( validSearchesWithoutPermission, function( search ) {
                return search.getNoteModel().desc;
            });

            var strNoteTypesWithCounts = '';
            for ( var noteType in oValidSearchesWithoutPermCountsPerNoteType ) {
                strNoteTypesWithCounts += noteType + ' (' + oValidSearchesWithoutPermCountsPerNoteType[noteType] + '), ';
            }
            strNoteTypesWithCounts = strNoteTypesWithCounts.substring( 0 , strNoteTypesWithCounts.length - 2 );

            permissionWarningMessage = 'User Lacks Permission to Create the Following Note Types: ' + strNoteTypesWithCounts;

        }

        /* Some Invalid Searches */

        if ( frApiModel.hasInvalidSearches() ) {

            if ( validSearchesWithoutPermission.length < 0 ) {

                showWarnings.call( this, {
                    shortMessage: 'Find And Redact API Invalid Input. ' + frApiModel.getInvalidSearches().length + ' Searches Not Included:',
                    detailedMsg: frApiModel.getValidationErrors().join('\n') // could later print out the provided text ...
                });

            } else {

                showWarnings.call( this, {
                    shortMessage: 'Find And Redact: ' + frApiModel.getInvalidSearches().length + ' Invalid Searches and '
                        + validSearchesWithoutPermission.length + ' Excluded Because of Permissions',
                    detailedMsg: frApiModel.getValidationErrors().join('\n') + // could later print out the provided text ...
                         '\n' + permissionWarningMessage
                });

            }

            return;
        }


        /* All valid -- just permissions */
        if ( validSearchesWithoutPermission.length > 0 ) {

            showWarnings.call( this, {
                shortMessage: 'Find and Redact: ' + validSearchesWithoutPermission.length + ' Searches Not Included Because of Permissions',
                detailedMsg: permissionWarningMessage
            });
            return;
        }


        function showWarnings( options ) {

            console.warn( options.shortMessage + '.  ' + options.detailedMsg );

            this.vChannel.trigger('alert:show', {
                type: 'info',
                shortMessage: options.shortMessage,
                detailedMsg: options.detailedMsg,
                detailedMsgPreserveLineBreaks: 1
            });

        }

    },

    /**
     * Now -- can only be called when there are results, one at a time; 'live.'
     */
    showAddSearchModal: function( ) {

        var searchFromView = new SearchView({
            model: this.request( 'getNewSearchModel'),
            channel: this.channel,
            submitButtonTitle: 'OK',
            extraFormClassName: 'fr-search-form-modal',
            focusInputOnShow: true,
            onSubmit: function( searchModel ) {
                this.vChannel.trigger( 'modal:close' );
                this.addSearch( searchModel );

            }.bind( this )

        });

        this.vChannel.trigger( 'modal:open', {
            hideFooter: true, // We use this form's button as the submit for now ...
            title: 'Add Search',
            content: searchFromView
        } );

    },

    showEditSearchModal: function( search ) {

        var searchFromView = new SearchView({
            model: search.getClone(),
            channel: this.channel,
            submitButtonTitle: 'OK',
            extraFormClassName: 'fr-search-form-modal',
            focusInputOnShow: true,
            onSubmit: function( clonedSearch ) {

                this.vChannel.trigger( 'modal:close' );

                if ( !search.isTheSameAsOtherSearch( clonedSearch ) ) {
                    this.editSearch( search, clonedSearch );
                }

            }.bind( this )

        });

        this.vChannel.trigger( 'modal:open', {
            hideFooter: true,
            title: 'Edit Search',
            content: searchFromView
        } );

    },

    addSearch: function( searchModel ) {

        this.channel.trigger('findAndRedact:showSpinner'); // now in layout too in case ...

        searchModel.setNoteSubjectOnSearch();

        this.state.addSearch( searchModel );

        this.state.get('searchResults').addSearchesToResults( [searchModel], this.channel );

        // Maybe need spinner, etc from search ... but don't want all same things
        this.layout.showBodyRegions();

        searchModel.updateLocalStorageForRedactionNotes();

        /* Note: for now it is not live, you can just refresh with the empty new search */
        this.vChannel.command( 'updateToReflectFindAndRedactSearch' );

    },

    editSearch: function( originalSearchToRemove, newSearchToAdd ) {

        this.state.removeSearch( originalSearchToRemove, 1 ); // yikes: if there are none, it will set the results to none
        this.addSearch( newSearchToAdd );

    },

    removeSearch: function( searchModel ) {

        this.state.removeSearch( searchModel );

        this.layout.showBodyRegions();

        /* Can't just re-render canvas -- see issue in code with floating redactions */
        this.vChannel.command( 'updateToReflectFindAndRedactSearch' );

    },

    /* Now really more of a 'reset' */
    clearSearch: function() {

        this.state.clearSearch();
        this.layout.showBodyRegions();
        this.vChannel.command( 'setFindAndRedactSearchModel', this.state );

    },

    updateShowResultsByTable: function( showResultsByPage ) {

        // 'clear' the view prior to re-rendering calc and then the entire layout -- POC
        // alternative is to show a loading view in it .... see layout comments ...
        this.layout.getRegion( 'resultsRegion' ).currentView.getRegion( 'hitsTableRegion' ).empty(); // ( only need the bottom ) --

        this.state.set({ showResultsByPage: showResultsByPage });
        this.state.get('searchResults').updateTreeStateFromHits( showResultsByPage );

        this.layout.showBodyRegions();

    },

    toggleCollapseSearch: function( search ) {

        var resultsTree = this.state.getSearchResultsTree();

        if ( search.get('isSelected') ) {

            search.set( 'isSelected', false );
            resultsTree.unCollapseAll();

        } else {

            this.state.get('searches').resetSelectedSearch();
            search.set( 'isSelected', true );

            resultsTree.collapseAllButSearch( search );
        }

        /* Don't want expensive table re-render */
        resultsTree.walkDown(function (node) {
            node.trigger('updateIsCollapsed');
        });

        this.channel.trigger('findAndRedact:updateSearchPills');

    },

    updatePostCollapseRowClick: function( rowModel ) {

        var resultsTree = this.state.getSearchResultsTree();
        resultsTree.updateHierarchyCollapsed( rowModel );

        /* Don't do expensive re-render */
        resultsTree.walkDown( function(node) {
            node.trigger('updateIsCollapsed');
        });

        /* -- update selected UI -- */
        this.state.get('searches').resetSelectedSearch();
        this.channel.trigger('findAndRedact:updateSearchPills');

    },

    updatePostResultRowIncludeClick: function( rowModel ) {

        var resultsTree = this.state.getSearchResultsTree();
        resultsTree.updateHierarchyIncludes( rowModel );

        /* Don't do expensive re-render */
        resultsTree.walkDown( function(node) {
            node.trigger('updateIsApplied');
        });

        // Update the 'action row' -- maybe later combo that row in the hierarchy
        this.channel.trigger('findAndRedact:updateActionRow');

    },

    userClickedHit: function( hitModel ) {
        this.vChannel.trigger('findAndRedact:goToHit', hitModel ); // may not need to pass the model now
    },

    revertShapePosition: function( hitModel ) {

        this.vChannel.trigger( 'findAndReact:revertShapePosition', hitModel );

    },

    // Only 1 shape per hit
    hitShapeReasonCodesChange: function( shape, selectedCodes ) {

        this.vChannel.trigger( 'findAndRedact:hitShapeReasonCodesChange', shape, selectedCodes );
    },

    /**
     * May also want 'report' object or object to return options for the alert message ...
     * but leaving like this since should have one endpoint for saving ... it we decide that's not the case,
     * clean this up.
     * This was just a POC to see how saving notes could work
     * If saving individually, would want to combo logic from the existing note models.
     */
    apply: function() {

        var vChannel = this.vChannel;

        var notesToSave = this.state.get('searchResults').getNotesToSaveFromAppliedHits();

        if (notesToSave.length < 0)
            return;

        /**
         * Save them ... should consolidate logic from note module, canvas etc ....
         * First setting the shapes on the note models
         * TODO: better way ...
         */

        var regNoteModelsToSave = [],  // we're cloning the notes to save
            activeDocModel = vChannel.request('activeDocument'), // for url creation
            scale = vChannel.request('getCurrentScaleValue');

        notesToSave.forEach( function(note) {

            // For now 'clone' the models - then we don't get a link back to those already saved, (unsure?)
            var regNoteModel = note.clone({
                parse: true,
                pageNumber: note.pageNumber // I think only need to set the pageNumber -- TODO: a better clone fn on the note
            });

            regNoteModel.frNoteId = note.cid; // provide a link back to the original for validation purposes ( not yet in use )

            /**
             * Update their shapes' properties from the zones prior to a save (from the shapes objects we put on them).
             * THIS ISN'T DONE LIVE NOW -- PROB SHOULD CHANGE ...
             * If a floating redaction and haven't been to its page,
             * //  TODO: now that there could be multiple floating per page, maybe only draw once for all of them ???
             * will need to draw the canvas to get the coordinates of the boxes, lines, etc.
             * Note: actually, even if we've have been to it's page, but have gone to another, the floating codes controller is gone
             * (see this not just for current the same page)
             * ( or don't destroy the controller, maybe just turn off it's events -- so we remember the positions ) -->
             * This would also happen if in doc mode and haven't loaded page mode yet -- even if on the same page, it wouldn't
             * the note wouldn't have a floating codes controller yet.
             */

            if ( note.isFloatingRedaction() && !note.floatingCodesController ) {

                // don't use vchannel command to avoid reference errors with the test one ...
                var dummyCanvas = new HiddenCanvasView();
                dummyCanvas.render( vChannel, note.pageNumber, note.shapes  );

                var canvasShapes = dummyCanvas.canvas.shapes.models; // reference maintained to the shapes here

                regNoteModel.set('shapes', canvasShapes.map( function(shape) {

                    var attrsToPersist = shape.getAttrsToPersist( scale ); // may no longer need scale since storing the points live

                    // if haven't been to the page, box would not have been set

                    // See below -- perhaps unnecessary since if on page, this will be called below with save hidden canvas,
                    // and also if not on page, it would have been saved on page navigation, but do anyway for now
                    if ( note.isFloatingRedaction() ) {
                        shape.set( attrsToPersist );
                        shape.parse( attrsToPersist ); // sets the box and connection; combo with update attributes to persist
                    }

                    return attrsToPersist; // area for override -- we don't want it getting points from raphaelEl

                }));

                // Comment this out for visual test;
                // But doing so may cause issues if multiple pages and then performing actions later. ( eg shapes not there )
               dummyCanvas.destroy();

            }

            else {

                regNoteModel.set( 'shapes', note.shapes.map( function(shape) {

                    var attrsToPersist = shape.getAttrsToPersist( scale );

                    // Set the code and box; and reset the attributes of the shape so it's remembered on re-render post save --
                    // Unlike with save, the attributes don't come back from the server prior to re-render remaining find and redact shape
                    // and go through the 'parse process'
                    // For now only for floating redaction ... show box is remembered re-render ... actually prob don't even need connection
                    // other attribute set other than points should be set directly on the shape model ...
                    // TODO: similar for shapeModel.updateShapeAttributes on floatingCodes shape model
                    if ( note.isFloatingRedaction() ) {

                        shape.set( attrsToPersist ); // would like a set and parse method perhaps ...
                        // perhaps this changes if we set box and connection on new shapes ... i don't think we do
                        // Maybe we only do if it was moved ... which we could check
                        shape.parse( attrsToPersist ); // may set the other attributes as well -- though they shouldn't change -- need box to reposition after save

                    }

                    return attrsToPersist; // area for override -- we don't want it getting points from raphaelEl

                }));

            }

            regNoteModelsToSave.push( regNoteModel );

        }, this);


        /**
         * Perform a client-side validation check at the note level first before any save is called ( after the shapes are set )
         * -- this is in case we can ever delete shapes -- THIS IS A REQUIREMENT
         * Must do after put shapes on them because that's looked at in base note validation ( for now ).
         * Easier to catch up front than mess with the failure logic on save, where you'd need to incorporate
         * 'invalid' notes with failed ones ( below ).
         * For now, this shouldn't really happen -- but it leaves open possibility, especially when implement note level result dropdowns.
         * For time being: only checking title (and now shapes), which is disabled and can't be changed anyway ---
         * currently title is blocked live on input so this should be reached.
         * If any are invalid -- mark as such,  and don't allow to proceed in case the user fixes in whatever
         * form they would have to if/when we implement note leave dropdowns ...
         * This way would also lend itself to not clearing the results and instead applying one x one as discussed ...
         * If left here, should be a separate fn ...
         * TODO: NOT DOING NOW -- UNECESSARY UNTIL WE CAN DELETE SHAPES, AT WHICH POINT CAN THINK OF BEST WAY TO ACCOMPLISH
         */

        /*
         var allNotesPassValidation = true;

         _.each( regNoteModelsToSave, function( note ) {

             note.set( 'title', 'This is a subject longer than 32 characters' ); //-- TO TEST DEBUG




             if ( !note.isValid() ) {


                // What to trigger on? could be 2 model? -- search or page
                // Last one got the model from the pageId of the note ...
                // noteResultsRowModel.trigger( 'pageRowResultModel:validationError', note.validationError );
                 allNotesPassValidation = false;
             }


         }, this);

         if ( !allNotesPassValidation ) {

             return;
         }
        */


        /*
         * Save process:
         * For now do the save in a separate loop --> should get from a 'getModelsToSaveFunction'
         * But leave dirty since will switch to bulk save endpoint
         */
        var self = this,

            hitsToApply = self.channel.request('state').get('searchResults').getAppliedHits(),

            numberNotesProcessed = 0,
            numberOfNotesToSave = regNoteModelsToSave.length,
            notesSaved = [], // { note, jqXHR }
            notesFailed = []; // { note, jqXHR }

        regNoteModelsToSave.map( function( note ) {

            /**
             * TODO -- later it's probably cleaner to have a bulk save endpoint, but that would prob
             * Send all attributes -- and for now save individually.
             * be a larger refactor with the current saving workflow in the client
             * this is something to look into when create notes bulk delete functionality.
             */

            note.save( [], {

                url: fvChannel.request('apiUrl').pageNote( activeDocModel, note.get('pageId') ), // since not in collection, url will break here ...

                success: function( model, response ) {

                    numberNotesProcessed++;

                    notesSaved.push( {
                        note: model,
                        jqXHR: response
                    } );

                    if ( numberNotesProcessed === numberOfNotesToSave ) {
                        postNotesSaved.call( self );
                    }

                },

                // response is jqXHR
                error: function( model, response, options ) {
                    // Handle or do with jqXHR

                    numberNotesProcessed++;

                    notesFailed.push( {
                        note: model,
                        jqXHR: response
                    } ); // use the failed model or the find and redact one?

                    if ( numberNotesProcessed === numberOfNotesToSave ) {
                        postNotesSaved.call( self );
                    }
                }

            });


        });


        function postNotesSaved() {

            // First process any saved note models in the current DV f'ed up workflow
            // We could sort them page # but this won't make any different
            // ctime may still be 'off' since called async -- would need bulk save endpoint here to fix this.

            notesSaved.map( function( noteSavedObj ) {

                /**
                 *  Add to allNotes collection
                 *  TODO: refactor and move this up
                 *  this should also create it in the notes view given current setup
                 *  appears auto-wired by the Marionette collection view
                 */
                vChannel.request('allNotes').add( noteSavedObj.note );

                // this adds to the various note collections ... separate that out
                vChannel.trigger( 'notes:noteSaved', noteSavedObj.note, {
                    noteSaved: true // this is picked up by something?  -- i think note.toggleEditMode, which would trigger the 'save' indicator on the view
                } );

                // Hack-work around to show the save indicator on the note view
                noteSavedObj.note.trigger('showSavedIndicator');


            });


            if ( notesSaved.length === numberOfNotesToSave ) {

                this.channel.request('vChannel').trigger('alert:show', {
                    type: 'success',
                    shortMessage: 'Created ' + notesSaved.length + ' note' + (notesSaved.length > 1 ? 's' : '') +
                    ' from ' + hitsToApply.length + ' hit' + (hitsToApply.length > 1 ? 's' : ''),
                    closeTimeout: 5000
                });


            } else if ( notesFailed.length === numberOfNotesToSave ) {

                this.channel.request('vChannel').trigger('alert:show', {
                    type: 'error',
                    shortMessage:
                        'Error creating ' + notesFailed.length + ' note' + (notesFailed.length > 1 ? 's' : '') +
                        ' from ' + hitsToApply.length + ' hit' + (hitsToApply.length > 1 ? 's' : ''),
                    detailedMsg: getDetailMsgForNotesThatFailed(),
                    detailedMsgPreserveLineBreaks: true
                });


            } else { // ( mixed success and failure )

                // TODO: use the new structure
                // Note: this is more reason to change top level structure of pageNotes and hits being on different objects
                // that are linked ... also see mess in table results ...
                var successFullHitsApplied = _.reduce( notesSaved, function( savedHits, savedNoteObj ) {

                   return savedHits.concat( _.filter( hitsToApply, function(hit) {
                       return hit.get('pageId') ===  savedNoteObj.note.get('pageId');
                   } ) );

                }, [] );

                var failedHitsApplied = _.reduce( notesFailed, function( failedHits, failedNoteObj ) {

                    return failedHits.concat( _.filter( hitsToApply, function(hit) {
                        return hit.get('pageId') ===  failedNoteObj.note.get('pageId');
                    } ) );

                }, [] );


                this.channel.request('vChannel').trigger('alert:show', {
                    type: 'info',
                    shortMessage:

                        'Created ' + notesSaved.length + ' note' + (notesSaved.length > 1 ? 's' : '') + // (shared)
                        ' from ' + successFullHitsApplied.length + ' hit' + (successFullHitsApplied.length > 1 ? 's' : ''),

                    detailedMsg:

                        'Error creating ' + notesFailed.length + ' note' + (notesFailed.length > 1 ? 's' : '') + // (shared)
                        ' from ' + failedHitsApplied.length + ' hit' + (failedHitsApplied.length > 1 ? 's' : '') + ':\n' +
                        getDetailMsgForNotesThatFailed(),

                    detailedMsgPreserveLineBreaks: true

                });

            }

            // For now we clear the search -- this may change -- AND I think now should
            this.channel.trigger('findAndRedact:clearSearch');


            // Probably should have a class but this is gonna paradigm should change with bulk save endpoint
            function getDetailMsgForNotesThatFailed() {

                // Get detailed err message for failed notes
                return _.reduce( notesFailed, function( msg, failedNoteObj, i ) {

                    var noteModel = failedNoteObj.note;
                    var pgNumber = noteModel.pageNumber;
                    var hitsToApplyOfPage = hitsToApply.filter( function(hit) {
                        return hit.get('pageId') === noteModel.get('pageId');
                    });

                    var nHitsToApplyOfPage = hitsToApplyOfPage.length;

                    msg += '* Page ' + pgNumber
                        + ' (' + nHitsToApplyOfPage + ' hit' +  (nHitsToApplyOfPage > 1 ? 's' : '') + '): '
                        + fvChannel.request( 'ajaxErrorMessage', failedNoteObj.jqXHR );

                    if ( i < notesFailed.length )
                        msg += '\n';

                    return msg;

                }, '' );

            }

        }

    },

    onBeforeDestroy: function() {

        this.region.empty();

        this.state = null;
        this.layout = null;

    }



});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/findAndRedact/module.js
 ** module id = 580
 ** module chunks = 0
 **/